/* packages/volto-castle-theme/src/components/Blocks/HPFeatures/HPFeatures.tsx */
import React from 'react';
import bg from '../../../static/img/backgrounds/1_back_hp.png';

type Item = {
  icon?: string;
  title?: string;
  text?: string;
};

type Props = {
  items: Item[];
  minHeight?: number;
  imagePosition?: string;
};

const Icon: React.FC<{ name?: string }> = ({ name }) => {
  if (name === 'calendar') {
    return (
      <svg width="52" height="52" viewBox="0 0 34 34" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm13 8H4v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10ZM19 6H5a1 1 0 0 0-1 1v1h16V7a1 1 0 0 0-1-1Z"
        />
      </svg>
    );
  }

  if (name === 'mobile') {
    return (
      <svg width="52" height="52" viewBox="0 0 34 34" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm10 2H7v16h10V4Zm-5 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
        />
      </svg>
    );
  }

  return (
    <svg width="52" height="52" viewBox="0 0 34 34" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M21 7.5a6 6 0 0 1-7.7 5.8l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9A6 6 0 0 1 16.5 3a4 4 0 0 0-4.2 4.9l2.8 2.8A4 4 0 0 0 21 7.5Z"
      />
    </svg>
  );
};

const HPFeatures: React.FC<Props> = ({ items, minHeight = 520, imagePosition = 'right center' }) => {
  const style: React.CSSProperties = {
    minHeight,
    backgroundImage: `url(${bg})`,
    backgroundPosition: imagePosition,
  };

  return (
    <section className="hp-features hp-features--fullbleed" style={style}>
      <div className="hp-features__container">
        <div className="hp-features__left">
          {items.map((it, idx) => (
            <div className="hp-features__item" key={`${it.title || 'item'}-${idx}`}>
              <div className="hp-features__icon">
                <Icon name={it.icon} />
              </div>
              <h3 className="hp-features__title">{it.title}</h3>
              <div className="hp-features__rule" />
              <p className="hp-features__text">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HPFeatures;
